module.exports = __webpack_public_path__ + "static/media/Casket.ea071932.png";